import { Construction } from 'lucide-react';
import { BosDurum } from '@emanetx/ui';

export function SayfaYakinda({ baslik }: { baslik: string }) {
  return (
    <div className="border-fume-300 dark:border-fume-700 dark:bg-fume-900 rounded-2xl border border-dashed bg-white py-16">
      <BosDurum
        ikon={Construction}
        baslik={`${baslik} — yakında`}
        aciklama="Bu modül sonraki adımda eklenecek. Faz 1'in geri kalan adımlarını tamamladıkça görünür hale gelecek."
      />
    </div>
  );
}
